<template>
  <div class="create-item">
    <!-- 上传标题 -->
    <div class="my-card">
      <div class="title">
        <img v-if="props.spu"
             :src="toUrl(spu?.image)">
        <p class="design-title">{{ spu?.name }}</p>
      </div>
      <a-button class="upload-button"
                @click="addCustomText">
        <plus-outlined class="upload-button-icon" />
        <span class="upload-button-title">{{ $t('CustomSpus.CreateItemPages.addText') }}</span>
      </a-button>
    </div>
    <div class="horizontal-bar"></div>
    <!-- 商品名称 -->
    <div class="my-card">
      <p class="fun-title">{{ $t('CustomSpus.CreateItemPages.productName') }}</p>
      <a-input v-model:value="customSpu.name"
               :allow-clear="true"
               :placeholder="$t('CustomSpus.CreateItemPages.enterHere')" />
    </div>
    <div class="horizontal-bar"></div>
    <!-- 产品颜色 -->
    <div class="my-card">
      <p class="fun-title">{{ $t('CustomSpus.CreateItemPages.color') }}</p>
      <div class="color-list">
        <div v-for="item in colors"
             class="color-item-border">
          <a-tooltip>
            <template #title>{{ item.name }}</template>
            <a-avatar :key="item.value"
                      shape="square"
                      :class="['color-item', colorShow(item) ? 'selected-color' : '']"
                      :alt='item.name'
                      :style="[item.image ? `backgroundImage:url(${item.image})` : `backgroundColor:${item.value}`,]"
                      @click="avatarShow(item)">
            </a-avatar>
          </a-tooltip>
        </div>
      </div>
      <div class="color-text">
        <p>-&nbsp;</p><span>{{ $t('CustomSpus.CreateItemPages.selectedColorPreview') }}</span>
      </div>
      <div class="color-text">
        <p>-&nbsp;</p><span>{{ $t('CustomSpus.CreateItemPages.selectedColorGenerate') }}</span>
      </div>
    </div>
    <div class="horizontal-bar"></div>
    <!-- 售价 -->
    <div class="my-card">
      <p class="fun-title">{{ $t('CustomSpus.CreateItemPages.price') }}</p>
      <PriceBreakdown :custom-price-detail="customPriceDetail"
                      :is-order="false"
                      :is-design="true"
                      :is-custom="!!props.isAreaCustomized.length" />
    </div>
  </div>
</template>


<script setup lang="ts">
import { computed, reactive, ref, watch } from 'vue'
import { } from "../../api/index"
import type { Color, CustomizedAreasScale, CustomPrice, CustomPriceDetail, CustomSpu, Spu } from '../../types'
import PriceBreakdown from "./PriceBreakdown.vue"
import { toUrl } from "@/utils"
const props = defineProps<{
  selectedColors: Color[]
  spu: Spu | undefined
  colors: Color[]
  isAreaCustomized: CustomPrice[]
  currentCustomAreaScale: CustomizedAreasScale[]
}>()

const emit = defineEmits([
  'update:selectedColors',
  'addCustomText',
  'changeCustomSpuName'
])

const customPriceDetail = ref<CustomPriceDetail>({
  spu_price: 0,
  customized_areas: [],
  custom_price: [],
  spu_discount:{}
})

// 商品名称售价
const customSpu = reactive<Partial<CustomSpu>>({
  name: '',
  // price: '',
})

watch(() => props.isAreaCustomized, () => {
  customPriceDetail.value.custom_price = props.isAreaCustomized
}, {
  deep: true,
  immediate: true
})

watch(() => props.spu?.price, () => {
  customPriceDetail.value.spu_price = props.spu?.price!
}, {
  immediate: true
})

watch(() => props.currentCustomAreaScale, () => {
  customPriceDetail.value.customized_areas = props.currentCustomAreaScale
}, {
  deep: true,
  immediate: true
})

watch(() => customSpu.name, () => {
  emit('changeCustomSpuName', customSpu.name)
})

const addCustomText = () => {
  emit('addCustomText')
}

/**
 *颜色块显示
 */
const colorShow = computed(() => (item: Color) => {
  return props.selectedColors.find(c => {
    return c.value === item.value
  })
})
// 颜色块
const clickValue = ref<Color[]>([])
/**
 *颜色块点击事件
 */
const avatarShow = (value: Color) => {
  clickValue.value = props.selectedColors
  const colorIndex = clickValue.value.findIndex(item => item.value == value.value)
  if (colorIndex != -1 && clickValue.value.length != 1) {
    clickValue.value.splice(colorIndex, 1)
  } else if (colorIndex != -1 && clickValue.value.length === 1) {
    // don't do anything action
  } else {
    clickValue.value.push(value)
  }
  emit('update:selectedColors', clickValue.value)
}

</script>
<style scoped lang="less">
.create-item {
  width: 300px;
  flex: 1;
  background: white;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  overflow: hidden;

  .title {
    display: flex;
  }

  .placeholder {
    flex: 1;
  }

  .color-grey {
    color: grey;
  }

  .horizontal-bar {
    width: 255px;
    margin-top: 15px;
    margin-left: 25px;
    border: 1px solid #F6F6F6;
  }

  .complete-button {
    width: 260px;
    height: 40px;
    color: white;
    background: #111111;
  }

  .my-card {
    margin: 10px 0;

    img {
      width: 60px;
      border: 1px solid #F1F1F1;
      height: 60px;
    }

    .design-title {
      margin-left: 23px;
      font-size: 16px;
      color: #111111;
    }

    .fun-title {
      display: inline-block;
      font-size: 16px;
      font-weight: 400;
      color: #111111;
      line-height: 20px;
      margin-bottom: 10px;
    }

    .color-text {
      display: flex;

      span {
        font-size: 14px;
        font-weight: 400;
        color: #999999;
      }
    }

    p {
      color: #111111ad;
    }

    .color-list {
      .color-item-border {
        margin-right: 4.5px;
        min-height: 36px !important;
        min-width: 36px !important;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        border: 1px solid rgb(215, 215, 215);

        .color-item {
          background-size: 100%;
          min-height: 36px !important;
          min-width: 36px !important;
        }

        .selected-color {
          border: 1px solid black;
        }
      }
    }
  }

  :deep(.ant-input-affix-wrapper) {
    width: 260px;
    height: 40px;
    border: 1px solid #F6F6F6 !important;
  }

  .upload-button {
    margin-top: 10px;
    border: none;
    width: 260px;
    height: 46px;
    background: #F6F6F6;
    display: flex;
    align-items: center;
    justify-content: center;

    .upload-button-icon {
      font-size: 16px;
    }

    .upload-button-title {
      font-size: 14px;
      font-weight: 400;
      color: #111111;
    }
  }

  .my-card:last-child {
    padding-left: 20px;
    overflow: auto;
  }
}
</style>
